import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rule-config" }
const _hoisted_2 = { class: "rule-inputs ion-padding" }
const _hoisted_3 = { slot: "label" }
const _hoisted_4 = { slot: "label" }
const _hoisted_5 = { class: "section-header" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "empty-state"
}

import { IonBackButton, IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonChip, IonContent, IonFab, IonFabButton, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonNote, IonPage, IonText, IonTitle, IonToggle, IonToolbar, modalController, onIonViewDidEnter  , onIonViewWillLeave } from '@ionic/vue';
import { addCircleOutline, closeCircle, saveOutline } from 'ionicons/icons'
import { translate } from "@hotwax/dxp-components";
import ProductFilters from '@/components/ProductFilters.vue';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import AddProductFacilityGroupModal from '@/components/AddProductFacilityGroupModal.vue';
import { RuleService } from '@/services/RuleService';
import { useRouter } from 'vue-router';
import logger from '@/logger';
import { generateRuleActions, generateRuleConditions, hasError, showToast } from '@/utils';
import emitter from '@/event-bus';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUpdateSafetyStockRule',
  props: ["ruleId"],
  setup(__props) {

const router = useRouter();
const store = useStore();

const formData = ref({
  ruleName: '',
  safetyStock: '',
  selectedFacilityGroups: {
    included: [],
    excluded: []
  },
  areAllFacilitiesSelected: false
}) as any;
const currentRule = ref({}) as any;
const props = __props;

const appliedFilters = computed(() => store.getters["util/getAppliedFilters"]);
const rules = computed(() => store.getters["rule/getRules"]);
const total = computed(() => store.getters["rule/getTotalRulesCount"])
const currentEComStore = computed(() => store.getters["user/getCurrentEComStore"])
const facilityGroups = computed(() => store.getters["util/getFacilityGroups"])

onIonViewDidEnter(async () => {
  emitter.on("productStoreOrConfigChanged", redirectLink);
  emitter.emit("presentLoader");
  await store.dispatch("util/fetchFacilityGroups")
  
  if(props.ruleId) {
    try {
      const resp = await RuleService.fetchRules({ ruleId: props.ruleId })

      if(!hasError(resp)) {
        currentRule.value = resp.data[0];

        formData.value.ruleName = currentRule.value.ruleName;
        formData.value.safetyStock = currentRule.value.ruleActions[0]?.fieldValue ? currentRule.value.ruleActions[0].fieldValue : ''

        const includedGroups = currentRule.value.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FAC_GROUPS" && condition.operator === "in")
        if(includedGroups?.fieldValue === "ALL") formData.value.areAllFacilitiesSelected = true;
        else {
          const includedGroupIds = includedGroups?.fieldValue ? includedGroups.fieldValue.split(",") : []
          formData.value.selectedFacilityGroups.included = facilityGroups.value.filter((group: any) => includedGroupIds.includes(group.facilityGroupId));

          const excludedGroups = currentRule.value.ruleConditions.find((condition: any) => condition.conditionTypeEnumId === "ENTCT_ATP_FAC_GROUPS" && condition.operator === "not-in")
          const excludedGroupIds = excludedGroups?.fieldValue ? excludedGroups.fieldValue.split(",") : []
          formData.value.selectedFacilityGroups.excluded = facilityGroups.value.filter((group: any) => excludedGroupIds.includes(group.facilityGroupId));
        }

        const currentAppliedFilters = JSON.parse(JSON.stringify(appliedFilters.value))
        currentRule.value.ruleConditions.map((condition: any) => {
          if(condition.conditionTypeEnumId === "ENTCT_ATP_FILTER") {
            if(condition.operator === "contains") {
              currentAppliedFilters["included"][condition.fieldName] = condition.fieldValue ? condition.fieldValue.split(",") : []
            } else {
              currentAppliedFilters["excluded"][condition.fieldName] = condition.fieldValue ? condition.fieldValue.split(",") : []
            }
          }
        })

        await store.dispatch('util/updateAppliedFilters', currentAppliedFilters)
      } else {
        throw resp.data
      }
    } catch(err: any) {
      logger.error(err);
    }
  }
  emitter.emit("dismissLoader");
})

onIonViewWillLeave(() => {
  formData.value = {
    ruleName: '',
    safetyStock: '',
    selectedFacilityGroups: {
      included: [],
      excluded: []
    }
  }
  store.dispatch("util/clearAppliedFilters")
  emitter.off("productStoreOrConfigChanged", redirectLink);
})

async function redirectLink() {
  router.push("/safety-stock");
}

async function openProductFacilityGroupModal(type: string) {
  const modal = await modalController.create({
    component: AddProductFacilityGroupModal,
    componentProps: {
      type,
      selectedFacilityGroups: formData.value.selectedFacilityGroups
    }
  })

  modal.onDidDismiss().then((result: any) => {
    if(result.data?.selectedGroups) {
      formData.value.selectedFacilityGroups[type] = result.data.selectedGroups
    }
  })

  modal.present()
}

async function createRule() {
  if(!isRuleValid()) return;

  emitter.emit("presentLoader");

  let ruleGroup = await store.dispatch("rule/fetchRuleGroup", { groupTypeEnumId: "RG_SAFETY_STOCK" });

  try {
    if(!ruleGroup.ruleGroupId) {
      ruleGroup = await RuleService.createRuleGroup({
        "groupTypeEnumId": "RG_SAFETY_STOCK",
        "productStoreId": currentEComStore.value.productStoreId,
        "statusId": "ATP_RG_ACTIVE"
      })
    }

    const params = {
      "ruleGroupId": ruleGroup.ruleGroupId,
      "ruleName": formData.value.ruleName,
      "statusId": "ATP_RULE_ACTIVE",
      "sequenceNum": total.value ? rules.value[total.value-1].sequenceNum + 1 : 1
    }

    const rule = await RuleService.createRule(params)
    await RuleService.updateRule({
      ...params,
      "ruleConditions": generateRuleConditions(rule.ruleId, "ENTCT_ATP_FAC_GROUPS", appliedFilters.value, formData.value.selectedFacilityGroups, formData.value.areAllFacilitiesSelected),
      "ruleActions": generateRuleActions(rule.ruleId, "ATP_SAFETY_STOCK", formData.value.safetyStock, false, [])
    }, rule.ruleId);

    showToast(translate("Rule created successfully."))
    store.dispatch("rule/clearRuleState")
    store.dispatch("util/clearAppliedFilters")
    router.push("/safety-stock");
  } catch(err: any) {
    logger.error(err);
    showToast(translate("Failed to create rule."))
  }
  emitter.emit("dismissLoader");
}

async function updateRule() {
  if(!isRuleValid()) return;

  const currentRuleConditions = JSON.parse(JSON.stringify(currentRule.value.ruleConditions));
  const updatedRuleConditions = generateRuleConditions(props.ruleId, "ENTCT_ATP_FAC_GROUPS", appliedFilters.value, formData.value.selectedFacilityGroups, formData.value.areAllFacilitiesSelected);

  updatedRuleConditions.map((updatedCondition: any) => {
    const current = currentRuleConditions.find((condition: any) => condition.conditionTypeEnumId === updatedCondition.conditionTypeEnumId && condition.fieldName === updatedCondition.fieldName && condition.operator === updatedCondition.operator);
    if(current) updatedCondition["conditionSeqId"] = current.conditionSeqId;
  })

  const conditionsToRemove = currentRuleConditions.filter((condition: any) => !updatedRuleConditions.some((updatedCondition: any) => condition.conditionTypeEnumId === updatedCondition.conditionTypeEnumId && condition.fieldName === updatedCondition.fieldName && condition.operator === updatedCondition.operator && condition.conditionSeqId === updatedCondition.conditionSeqId))

  try {
    await RuleService.updateRule({
      ...currentRule.value,
      "ruleName": formData.value.ruleName,
      "ruleConditions": updatedRuleConditions,
      "ruleActions": generateRuleActions(props.ruleId, "ATP_SAFETY_STOCK", formData.value.safetyStock, true, currentRule.value.ruleActions)
    }, props.ruleId);
    showToast(translate("Rule updated successfully."))

    const removeResponses = await Promise.allSettled(conditionsToRemove.map(async (condition: any) => await RuleService.deleteCondition({ ...condition, ruleId: props.ruleId})));
    const hasFailedResponse = removeResponses.some((response: any) => response.status === 'rejected');
    if(hasFailedResponse) logger.error("Failed to delete some rule conditions.")

    store.dispatch("rule/clearRuleState")
    store.dispatch("util/clearAppliedFilters")
    router.push("/safety-stock");
  } catch(err: any) {
    logger.error(err);
  }
}

function isRuleValid() {
  if(!formData.value.ruleName.trim() || !formData.value.safetyStock) {
    showToast(translate("Please fill in all the required fields."))
    return false;
  }

  if(formData.value.safetyStock < 0) {
    showToast(translate("Safety stock should be greater than or equal to 0."));
    return false;
  }

  if(!formData.value.areAllFacilitiesSelected && !formData.value.selectedFacilityGroups.included.length) {
    showToast(translate("Please include atleast one facility."))
    return false;
  }

  return true
}

function validateSafetyStock(event: any) {
  if(/[`!@#$%^&*()_+\-=\\|,.<>?~e]/.test(event.key) && event.key !== 'Backspace') event.preventDefault();
}

function removeFacilityGroups(facilityGroupId: any, type: string) {
  formData.value.selectedFacilityGroups[type] = formData.value.selectedFacilityGroups[type].filter((group: any) => group.facilityGroupId !== facilityGroupId)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonBackButton), {
                slot: "start",
                "default-href": "/safety-stock"
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.ruleId ? _unref(translate)("Edit safety stock rule") : _unref(translate)("New safety stock rule")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(IonCard), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCardHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCardTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Rule Configuration")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: formData.value.ruleName,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.ruleName) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(_unref(translate)("Name")) + " ", 1),
                              _createVNode(_unref(IonText), { color: "danger" }, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("*", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonInput), {
                          modelValue: formData.value.safetyStock,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.safetyStock) = $event)),
                          type: "number",
                          min: "0",
                          onKeydown: _cache[2] || (_cache[2] = ($event: any) => (validateSafetyStock($event)))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createTextVNode(_toDisplayString(_unref(translate)("Safety stock")) + " ", 1),
                              _createVNode(_unref(IonText), { color: "danger" }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("*", -1)
                                ]))]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(_unref(translate)("Facilities")) + " ", 1),
              _createVNode(_unref(IonText), { color: "danger" }, {
                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createTextVNode("*", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("section", null, [
            _createVNode(_unref(IonItem), { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonToggle), {
                  modelValue: formData.value.areAllFacilitiesSelected,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.areAllFacilitiesSelected) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("Select all facilities")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          (facilityGroups.value.length)
            ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                _createVNode(_unref(IonCard), {
                  disabled: formData.value.areAllFacilitiesSelected
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)("Included")) + " ", 1),
                            _createVNode(_unref(IonText), { color: "danger" }, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("*", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), {
                          fill: "clear",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (openProductFacilityGroupModal('included')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(addCircleOutline),
                              slot: "end"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardContent), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.selectedFacilityGroups['included'], (group) => {
                          return (_openBlock(), _createBlock(_unref(IonChip), {
                            outline: "",
                            key: group.facilityGroupId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(group.facilityGroupName ? group.facilityGroupName : group.facilityGroupId) + " ", 1),
                              _createVNode(_unref(IonIcon), {
                                icon: _unref(closeCircle),
                                onClick: ($event: any) => (removeFacilityGroups(group.facilityGroupId, 'included'))
                              }, null, 8, ["icon", "onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(IonCard), {
                  disabled: formData.value.areAllFacilitiesSelected
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)("Excluded")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), {
                          fill: "clear",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (openProductFacilityGroupModal('excluded')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)("Add")) + " ", 1),
                            _createVNode(_unref(IonIcon), {
                              icon: _unref(addCircleOutline),
                              slot: "end"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardContent), null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.selectedFacilityGroups['excluded'], (group) => {
                          return (_openBlock(), _createBlock(_unref(IonChip), {
                            outline: "",
                            key: group.facilityGroupId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(group.facilityGroupName ? group.facilityGroupName : group.facilityGroupId) + " ", 1),
                              _createVNode(_unref(IonIcon), {
                                icon: _unref(closeCircle),
                                onClick: ($event: any) => (removeFacilityGroups(group.facilityGroupId, 'excluded'))
                              }, null, 8, ["icon", "onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(IonNote), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(translate)("No facility group found for selected product store. Either change the product store or associate facility groups with the product store.")), 1)
                  ]),
                  _: 1
                })
              ])),
          _createVNode(ProductFilters)
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFab), {
        vertical: "bottom",
        horizontal: "end",
        slot: "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonFabButton), {
            disabled: !facilityGroups.value.length,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (currentRule.value.ruleId ? updateRule() : createRule()))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})